import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
    return (
      <Typewriter
        options={{
          strings: [
            "Risk Analyst",
            "Data Scientist"
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 60,
        }}
      />
    );
  }
  
  export default Type;